<template>
    <div v-if="isInput" class="gmf-rating-stars gmf-rating-stars-input" :class="['gmf-rating-stars-' + type, 'gmf-rating-stars-' + size]">
        <a href="#" class="gmf-rating-star" v-for="i in 5" :key="i" @click.stop.prevent="$emit('update:modelValue', i)" :title="i + ' / ' + max">
            <template v-if="i <= rating">
                <Icon class="gmf-active" :icon="iconFg" />
            </template>
            <template v-else>
                <Icon :icon="iconBg" />
            </template>
        </a>
    </div>
    <div v-else class="gmf-rating-stars" :class="['gmf-rating-stars-' + type, 'gmf-rating-stars-' + size]" :title="title">
        <div class="gmf-rating-star" v-for="i in 5" :key="i">
            <template v-if="!isInteger && i == partialIndex">
                <Icon :icon="iconBg" />
                <div class="gmf-rating-star-partial" :style="{ width: partialWidth }">
                    <Icon class="gmf-active" :icon="iconFg" :style="{ width: inversePartialWidth }" />
                </div>
            </template>
            <template v-else-if="i <= rating">
                <Icon class="gmf-active" :icon="iconFg" />
            </template>
            <template v-else>
                <Icon :icon="iconBg" />
            </template>
        </div>
    </div>
</template>

<style>
.gmf-rating-stars,
.gmf-rating-stars * {
    line-height: 0 !important;
}

.gmf-rating-stars {
    display: flex;
    position: relative;
}

.gmf-rating-star-partial {
    height: 100%;
    overflow: hidden;
    position: relative;
}

.gmf-rating-stars * {
    pointer-events: none;
}

.gmf-rating-star {
    width: 20px;
    height: 20px;
    position: relative;
    --gmf-icon-color: var(--gmf-col-gray);
}

.gmf-rating-stars-small .gmf-rating-star {
    width: 16px;
    height: 16px;
}

.gmf-rating-stars-large .gmf-rating-star {
    width: 24px;
    height: 24px;
}


.gmf-rating-star .gmf-icon {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}

.gmf-rating-stars-input .gmf-rating-star {
    cursor: pointer;
    width: 40px;
    height: 40px;
    pointer-events: all;
}

.gmf-rating-stars-product_score .gmf-active {
    --gmf-icon-color: var(--gmf-col-product_score);
}
.gmf-rating-stars-site_score .gmf-active {
    --gmf-icon-color: var(--gmf-col-site_score);
}
.gmf-rating-stars-hype_factor .gmf-active {
    --gmf-icon-color: var(--gmf-col-hype_factor);
}
</style>

<script>
import Icon from '@/components/Icon';

export default {
    name: 'RatingStars',
    components: {
        Icon,
    },
    props: {
        type: {
            type: String,
            default: 'product_score',
        },
        rating: {
            type: Number,
            required: true,
        },
        isInput: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'medium',
            validator (value) {
                return ['small', 'medium', 'large'].includes(value);
            },
        },
    },
    computed: {
        title() {
            return this.rating.toFixed(1) + ' / ' + this.max;
        },
        isInteger() {
            return this.isInput || Number.isInteger(this.rating);
        },
        partialIndex() {
            return Math.floor(this.rating) + 1;
        },
        partialRemainder () {
            return this.rating % 1;
        },
        partialWidth() {
            return this.partialRemainder * 100 + '%';
        },
        inversePartialWidth() {
            return (1 / this.partialRemainder) * 100 + '%';
        },
        max() {
            return 5; // @TODO could be different?
        },
        fillStyle() {
            return {
                width: (this.rating / this.max * 100) + '%',
            };
        },
        iconBg() {
            return this.type + '-gray';
        },
        iconFg() {
            return this.type;
        },
    },
};
</script>